<button
  type="button"
  class="theme-card relative flex aspect-[4/3] w-full cursor-pointer flex-col items-center justify-center gap-3 overflow-hidden rounded-xl border border-white/10 bg-surface-container p-3 text-center"
  [class.theme-card--primary]="variant() === 'primary'"
  [class.theme-card--secondary]="variant() === 'secondary'"
  [class.theme-card--tertiary]="variant() === 'tertiary'"
>
  <span class="theme-card__corners" aria-hidden="true"></span>
  <span
    class="theme-card__icon material-symbols-outlined relative z-10 text-4xl"
    style="font-variation-settings: 'FILL' 1"
    >{{ icon() }}</span
  >
  <h3
    class="theme-card__label relative z-10 line-clamp-2 font-headline-sm text-headline-sm text-on-surface"
  >
    {{ label() }}
  </h3>
</button>
